import axios, { AxiosRequestConfig } from 'axios'
import * as R from 'ramda'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import hostConfig from '$config/frontend'
import { getClientUserIdentityToken } from '$logic/auth'

const instance = axios.create({
  baseURL: hostConfig.WAPP_ACTIVITY_HOST,
})

export async function postRequest<T>(
  url: string,
  data: any,
  config?: AxiosRequestConfig,
) {
  const token = await getClientUserIdentityToken()
  return instance.post<T>(
    url,
    data,
    R.assocPath(['headers', 'Authorization'], `Bearer ${token}`, config),
  )
}

export async function putRequest<T>(
  url: string,
  data: any,
  config?: AxiosRequestConfig,
) {
  const token = await getClientUserIdentityToken()
  return instance.put<T>(
    url,
    data,
    R.assocPath(['headers', 'Authorization'], `Bearer ${token}`, config),
  )
}

export async function deleteRequest<T>(
  url: string,
  data: any,
  config?: AxiosRequestConfig,
) {
  const token = await getClientUserIdentityToken()
  return instance.delete<T>(url, {
    data,
    ...R.assocPath(['headers', 'Authorization'], `Bearer ${token}`, config),
  })
}
